import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
/**
 * @author: Shoukath Mohammed
 */
var SpinnerService = /** @class */ (function () {
    function SpinnerService() {
        /**
         * @description: An observable that emits spinner events.
         */
        this.display$ = new BehaviorSubject(false);
    }
    /**
     * public
     * @return: void
     * @description: a helper function to show the spinner.
     */
    SpinnerService.prototype.show = function () {
        this.display$.next(true);
    };
    /**
     * public
     * @return: void
     * @description: a helper function to hide the spinner.
     */
    SpinnerService.prototype.hide = function () {
        this.display$.next(false);
    };
    /**
     * public
     * @return: void
     * @description: a helper function that lets other subscribe
     * to the spinner view.
     */
    SpinnerService.prototype.load = function () {
        return this.display$;
    };
    SpinnerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SpinnerService_Factory() { return new SpinnerService(); }, token: SpinnerService, providedIn: "root" });
    return SpinnerService;
}());
export { SpinnerService };
